import {
  blog04,
  blog05,
  blog06,
  fproduct01,
  fproduct02,
  fproduct03,
  product01,
  product02,
  product03,
  product04,
  product05,
  product06,
  product07,
  product08,
  product09,
  product10,
  product11,
  product12,
  product13,
  product14,
  product15,
  product16,
  banner01,
  banner02,
  banner03,
} from "../assets/export";

export const blogData = [
  {
    img: blog04,
    date: "22",
    title: "8 Inspiring Ways to Wear Dresses in the Winter",
    text: "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Fusce eget dictum tortor. Donec dictum vitae sapien eu varius",
  },
  {
    img: blog05,
    date: "18",
    title: "The Great Big List of Men’s Gifts for the Holidays",
    text: "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Fusce eget dictum tortor. Donec dictum vitae sapien eu varius",
  },
  {
    img: blog06,
    date: "16",
    title: "5 Winter-to-Spring Fashion Trends to Try Now",
    text: "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Fusce eget dictum tortor. Donec dictum vitae sapien eu varius",
  },
];
export const featuredProductsData = [
  {
    id: 1,
    img: fproduct01,
    price: "$19.00",
    details: "White Shirt With Pleat Detail Back",
  },
  {
    id: 2,
    img: fproduct02,
    price: "$39.00",
    details: "Converse All Star Hi Black Canvas",
  },
  {
    id: 3,
    img: fproduct03,
    price: "$17.00",
    details: "Nixon Porter Leather Watch In Tan",
  },
];
export const archiveData = [
  {
    id: 1,
    date: "July 2018",
    amount: "(9)",
  },
  {
    id: 2,
    date: "June 2018",
    amount: "(39)",
  },
  {
    id: 3,
    date: "May 2018",
    amount: "(29)",
  },
  {
    id: 4,
    date: "April 2018",
    amount: "(35)",
  },
  {
    id: 5,
    date: "March 2018",
    amount: "(22)",
  },
  {
    id: 6,
    date: "February 2018",
    amount: "(32)",
  },
  {
    id: 7,
    date: "January 2018",
    amount: "(21)",
  },
  {
    id: 8,
    date: "December 2017",
    amount: "(26)",
  },
];

export const productsData = [
  {
    id: 1,
    img: product01,
    brand: "Esprit Ruffle Shirt",
    price: 16.64,
    category: "Women",
  },
  {
    id: 2,
    img: product02,
    brand: "Herschel supply",
    price: 35.31,
    category: "Women",
  },
  {
    id: 3,
    img: product03,
    brand: "Only Check Trouser",
    price: 25.52,
    category: "Men",
  },
  {
    id: 4,
    img: product04,
    brand: "Classic Trench Coat",
    price: 75.01,
    category: "Women",
  },
  {
    id: 5,
    img: product05,
    brand: "Front Pocket Jumper",
    price: 34.75,
    category: "Women",
  },
  {
    id: 6,
    img: product06,
    brand: "Vintage Inspired Classic",
    price: 93.24,
    category: "Accessories",
  },
  {
    id: 7,
    img: product07,
    brand: "Shirt in Stretch Cotton",
    price: 52.66,
    category: "Women",
  },
  {
    id: 8,
    img: product08,
    brand: "Pieces Metallic Printed",
    price: 18.96,
    category: "Women",
  },
  {
    id: 9,
    img: product09,
    brand: "Converse All Star Hi Plimsolls",
    price: 75.05,
    category: "Accessories",
  },
  {
    id: 10,
    img: product10,
    brand: "Femme T-Shirt In Stripe",
    price: 25.85,
    category: "Women",
  },
  {
    id: 11,
    img: product11,
    brand: "Herschel supply",
    price: 63.16,
    category: "Men",
  },
  {
    id: 12,
    img: product12,
    brand: "Herschel supply",
    price: 63.15,
    category: "Accessories",
  },
  {
    id: 13,
    img: product13,
    brand: "T-Shirt with Sleeve",
    price: 18.49,
    category: "Women",
  },
  {
    id: 14,
    img: product14,
    brand: "Pretty Little Thing",
    price: 54.79,
    category: "Women",
  },
  {
    id: 15,
    img: product15,
    brand: "Mini Silver Mesh Watch",
    price: 86.85,
    category: "Accessories",
  },
  {
    id: 16,
    img: product16,
    brand: "Square Neck Back",
    price: 29.64,
    category: "Women",
  },
];

export const tabsData = [
  {
    id: 0,
    title: "Description",
    content:
      "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc.",
  },
  {
    id: 1,
    title: "Additional Information",
    content:
      "Weight - 0.79kg,                                                                                                  Dimensions - 110 x 33 x 100 cm,                                                                            Materials - 60% cotton,                                                                                                       Color - Black, Blue, Grey, Green, Red, White,                                                                   Size - XL, L, M, S",
  },
  {
    id: 2,
    title: "Review (1)",
    content:
      "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc.",
  },
];

export const relatedProductsData = [
  {
    id: 11,
    img: product11,
    brand: "Herschel supply",
    price: 63.16,
    category: "Men",
  },
  {
    id: 12,
    img: product12,
    brand: "Herschel supply",
    price: 63.15,
    category: "Accessories",
  },
  {
    id: 13,
    img: product13,
    brand: "T-Shirt with Sleeve",
    price: 18.49,
    category: "Women",
  },
  {
    id: 7,
    img: product07,
    brand: "Shirt in Stretch Cotton",
    price: 52.66,
    category: "Women",
  },
];

export const homeData = [
  {
    img: banner01,
    category: "Women",
    season: "Spring 2023",
  },
  {
    img: banner02,
    category: "Men",
    season: "Spring 2023",
  },
  {
    img: banner03,
    category: "Accessories",
    season: "New Trend",
  },
];
export const homeBannerData = [
  "./assests/slide-01",
  "./assests/slide-02",
  "./assests/slide-03",
  "./assests/slide-04",
];

export const navLinks = [
  {
    id: "",
    title: "Home",
  },
  {
    id: "shop",
    title: "Shop",
  },
  // {
  //   id: "features",
  //   title: "Features",
  // },
  {
    id: "blog",
    title: "Blog",
  },
  {
    id: "about",
    title: "About",
  },
  {
    id: "contact",
    title: "Contact",
  },
];
